import React, { useState } from 'react';
import { Row, Col, Form, Button, Popconfirm } from 'antd';
import TextArea from '../../../../ui/TextArea'
import Collapse, {Panel} from '../../../../ui/Collapse';
import { CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';

interface propsTypes {
  dataList: void | any,
  currentForm: void | any,
}
interface dataType {
  name: string
}
const UsageProgramsEdit = (props: propsTypes) => {
  const data = props.dataList?.environmentalimpact?.energyusage?.usageprogram || [];
  const [panelList, setPanelList] = useState(data)
  const [refreshCount, setRefreshCount] = useState(0);
  const addClick = () => {
    const newpanelList = panelList.concat([{ desc: ' ' }]);
    setPanelList(newpanelList);
    setRefreshCount(refreshCount + 1);
  }
  const closeClick = (index: number) => {

    const validData = panelList.filter((item: any, i: number) => item.desc)
    if (validData.length > 1) {
      const _panelList = JSON.parse(JSON.stringify(panelList))
      _panelList[index].desc = null;
      setPanelList(_panelList)
    }
    props.currentForm.setFieldsValue({
      [`desc-${index}`]: ''
    })
  }

  return (
    <>
      <Collapse defaultActiveKey={panelList.map((_: object, i : number) => i)} multiCollapseButton key={refreshCount}>
        {panelList.map((item: { desc: string; }, i: number) =>
          <React.Fragment key={i}>
            {
               <Panel
                  header={`Energy Usage Program ${i + 1}`}
                  key={i}
                  style={{ marginBottom: '20px' }}
                  deleteButton={{
                    action: () => closeClick(i),
                    title: `Are you sure you want to delete Energy Usage Program ${i + 1}?`,
                  }}
                >
                  <Row gutter={24}>
                    <Col span={18}>
                      <Form.Item
                        name={`desc-${i}`}
                        label='Description'
                        rules={[{ max: 150, message: 'You have reached the max character length of 150' }]}
                      >
                        <TextArea maxLength={150} maxRows={3} style={{ resize: 'none' }} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>    
            }
          </React.Fragment>
        )}
      </Collapse>
      <Button
        type="link"
        onClick={addClick}
        icon={<PlusOutlined />}
        style={{ display: 'flex', alignItems: 'center', background: '#fff', float: 'right' }}
      >
        {`Add Energy Usage Program ${panelList.length + 1}`}
      </Button>
    </>
  )
}


export default UsageProgramsEdit;
